import React, { Component } from "react";
import LangContext from "../../contextProvider/LangContext";
import { Button, Icon, Card, Form, InputNumber, Input, Checkbox } from "antd";
import { Job, User, OutputType, ProcessType } from "../../JmReact";
import GenericModal from "../../components/GenericModal";
import DateTimePicker from "../../components/DateTimePicker";



class DashboardDinamic extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            modalParameters: null,
            modalTemplate: null,
            modalTemplateViewHtml: null,
        }

        this.id = "DASHBOARD_DINAMIC";

        this.api = {
            get: "get_dashboard_dinamic",
            template: "get_dashboard_dinamic_data",
        }

        if (props.data[this.id] === undefined) { props.data[this.id] = { dataset: [] } }
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    apiData = () => {
        this.sendAPI(this.api.get, "", (ob) => {
            this.setState({ modalOpen: true }, () => {
                this.props.dataActions.setJson(this.id, {
                    dataset: ob.data.split("\r").map(x => {
                        const [_id, _name, _desc, _template, _parameters, _order] = x.split("\f")
                        return { _id, _name, _desc, _template, _parameterList: _parameters?.indexOf("{") > -1 ? JSON.parse(_parameters) : [], _order }
                    })
                })
            })
        })
    }

    apiTemplate = () => {
        const { _id, _jsonParameters } = this.state.modalTemplate ?? {};
        this.sendAPI(this.api.template, { _id, _jsonParameters }, (ob) => {
            let data = ob.data?.indexOf("{") > -1 ? JSON.parse(ob.data) : {};
            console.log("test_renderTemplate", ob.data);

            this.setState({ modalTemplateViewHtml: this.renderTemplate(this.state.modalTemplate?._template, data) })
        })
    }

    renderTemplate = (template, data) => {
        const expandItems = (blockTemplate, items) => {
            return items.map(item => {
                let rendered = blockTemplate;

                rendered = rendered.replace(
                    /<!--#(\w+)#_START-->([\s\S]*?)<!--#\1#_END-->/g,
                    (match, fieldName, innerTemplate) => {
                        const dataKey = item[fieldName];
                        const nestedItems = data[dataKey] || [];
                        if (!Array.isArray(nestedItems)) return '';
                        return nestedItems.map(nestedItem => {
                            let inner = innerTemplate;
                            for (const [key, value] of Object.entries(nestedItem)) {
                                if (Array.isArray(value)) continue;
                                inner = inner.replaceAll(`#${key}#`, value ?? '');
                            }
                            return inner;
                        }).join('');
                    }
                );

                for (const [key, value] of Object.entries(item)) {
                    if (Array.isArray(value)) continue;
                    rendered = rendered.replaceAll(`#${key}#`, value ?? '');
                }

                return rendered;
            }).join('');
        };

        let html = template.replace(
            /<!--(\w+)_START-->([\s\S]*?)<!--\1_END-->/g,
            (match, arrayKey, blockTemplate) => {
                const items = data[arrayKey] || [];
                if (!Array.isArray(items)) return '';
                return expandItems(blockTemplate, items);
            }
        );

        for (const [key, value] of Object.entries(data)) {
            if (Array.isArray(value)) continue;
            html = html.replaceAll(`#${key}#`, value ?? '');
        }

        return html;
    }

    render() {
    
        return (<div style={{ textAlign: "center", marginBottom: 5, display: 'inline-block', verticalAlign: 'text-top' }}>
            <Button onClick={this.apiData}>
                <Icon type={"cloud"} style={{ marginLeft: 5 }} />
                DASHBOARDS
            </Button>
            <GenericModal
                visible={this.state.modalOpen}
                onCancel={() => { this.setState({ modalOpen: false }) }}
                title="DASHBOARDS"
                width={800}
            >
                {this.props.data[this.id]?.dataset?.map(x => {
                    return (
                        <Card key={x._id} style={{ width: 250, display: "inline-block", verticalAlign: 'text-top', margin: 10, cursor: 'pointer' }} onClick={() => {
                            if (x._parameterList?.length > 0) {
                                this.setState({ modalParameters: x })
                            } else {
                                this.setState({ modalTemplate: { ...x, _jsonParameters: "{}" } }, this.apiTemplate)
                            }
                        }}>
                            <h3>{x._name}</h3>
                            <p>{x._desc}</p>
                        </Card>
                    )
                })}
            </GenericModal>
            <GenericModal
                visible={this.state.modalParameters != null}
                onCancel={() => { this.setState({ modalParameters: null }) }}
                title={this.state.modalParameters?._name}
                width={this.state.modalParameters?._parameterList?.length <= 4 ? 500 : this.state.modalParameters?._parameterList?.length <= 8 ? 1000 : undefined}
                footer={[
                    <Button key="cancel" onClick={() => { this.setState({ modalParameters: null }) }}>{this.getText(22734)}</Button>,
                    <Button key="view" type="primary" onClick={() => {
                        let jsonParameters = {}
                        if (this.state.modalParameters) this.state.modalParameters._parameterList.forEach(y => { jsonParameters = { ...jsonParameters, [y.id]: y.value } });
                        this.setState({ modalTemplate: { ...this.state.modalParameters, _jsonParameters: JSON.stringify(jsonParameters) } }, this.apiTemplate)
                    }}>{this.getText(22733)}</Button>
                ]}
            >
                <Form style={{ columnCount: this.state.modalParameters?._parameterList?.length <= 4 ? 1 : this.state.modalParameters?._parameterList?.length <= 8 ? 2 : 3 }}>
                    {this.state.modalParameters?._parameterList?.map(x => {
                        const onChange = (value) => {
                            this.setState({ modalParameters: { ...this.state.modalParameters, _parameterList: this.state.modalParameters?._parameterList.map(y => y.id === x.id ? { ...y, value } : y) } })
                        }
                        return (<Form.Item key={x.id} label={x.label}>
                            {x.type === "date" ? <DateTimePicker format="DD/MM/YYYY" value={x.value} onChange={onChange} />
                                : x.type === "number" ? <InputNumber min={x.min} max={x.max} value={x.value} onChange={onChange} />
                                    : x.type === "text" ? <Input value={x.value} onChange={e => onChange(e.target.value)} />
                                        : x.type === "checkbox" ? <Checkbox checked={x.value == '1'} onChange={e => onChange(e.target.checked ? '1' : '0')} >{x.description}</Checkbox>
                                            : ""}
                        </Form.Item>)
                    })}
                </Form>
            </GenericModal>
            <GenericModal
                visible={this.state.modalTemplate != null}
                onCancel={() => { this.setState({ modalTemplate: null }) }}
                title={this.state.modalTemplate?._name}
            >
                {/* <div id="dashboard-container" dangerouslySetInnerHTML={{ __html: this.state.modalTemplateViewHtml ?? "" }} /> */}
                <iframe
                    //   title={this.state.modalTemplate?._name}
                    onLoad={() => {
                        console.log("test_onLoad", this.renderTemplate(this.state.modalTemplate?._template, {"sumAll":231370.00,"countAll":3055,"avgAll":1518.73,"branches":[{"branchID":1,"branchName":"טרמינל 1","qty":420,"sum":34432.00,"avg":351.57,"detailedKey":"detailedBranch1"},{"branchID":2,"branchName":"טרמינל 3","qty":1239,"sum":102038.00,"avg":362.90,"detailedKey":"detailedBranch2"},{"branchID":3,"branchName":"ח.א. תמך","qty":418,"sum":40700.00,"avg":477.54,"detailedKey":"detailedBranch3"},{"branchID":4,"branchName":"שינוע","qty":688,"sum":35179.00,"avg":51.13,"detailedKey":"detailedBranch4"},{"branchID":5,"branchName":"בית קפה  תמך","qty":290,"sum":19021.00,"avg":275.59,"detailedKey":"detailedBranch5"}],"detailedBranch1":[{"paymentDescription":"תקציב מולטיפאס","qty":420,"sum":34432.00,"avg":351.57}],"detailedBranch2":[{"paymentDescription":"תקציב מולטיפאס","qty":1239,"sum":102038.00,"avg":362.90}],"detailedBranch3":[{"paymentDescription":"תקציב מולטיפאס","qty":418,"sum":40700.00,"avg":477.54}],"detailedBranch4":[{"paymentDescription":"תקציב מולטיפאס","qty":688,"sum":35179.00,"avg":51.13}],"detailedBranch5":[{"paymentDescription":"תקציב מולטיפאס","qty":290,"sum":19021.00,"avg":275.59}],"storages":[{"storageID":1,"storageName":"טרמינל 1","qty":420,"sum":34432.00,"avg":351.57},{"storageID":2,"storageName":"טרמינל 3","qty":1239,"sum":102038.00,"avg":362.90},{"storageID":3,"storageName":"ח.א. תמך","qty":418,"sum":40700.00,"avg":477.54},{"storageID":4,"storageName":"שינוע","qty":688,"sum":35179.00,"avg":51.13},{"storageID":5,"storageName":"בית קפה תמך","qty":290,"sum":19021.00,"avg":275.59}],"pos":[{"posID":10,"posName":"טרמינל 1 - עמדה 10","qty":86,"sum":8300.00,"avg":96.51},{"posID":11,"posName":"טרמינל 1 - עמדה 11","qty":86,"sum":7950.00,"avg":92.44},{"posID":12,"posName":"טרמינל 1 - עמדה 12","qty":53,"sum":5050.00,"avg":95.28},{"posID":13,"posName":"טרמינל 1 - עמדה 13 קפיטריה","qty":195,"sum":13132.00,"avg":67.34},{"posID":20,"posName":"טרמינל 3 - עמדה 20","qty":164,"sum":16200.00,"avg":98.78},{"posID":21,"posName":"טרמינל 3 - עמדה 21","qty":204,"sum":19750.00,"avg":96.81},{"posID":22,"posName":"טרמינל 3 - עמדה 22","qty":172,"sum":16600.00,"avg":96.51},{"posID":23,"posName":"טרמינל 3 - עמדה 23 קפיטריה","qty":699,"sum":49488.00,"avg":70.80},{"posID":30,"posName":"תמך - עמדה 30 ח.א.","qty":175,"sum":17050.00,"avg":97.43},{"posID":31,"posName":"תמך - עמדה 31 ח.א.","qty":109,"sum":10700.00,"avg":98.17},{"posID":32,"posName":"תמך - עמדה 32 ח.א.","qty":96,"sum":9450.00,"avg":98.44},{"posID":37,"posName":"תמך - עמדה 37 - ח.א.","qty":11,"sum":1000.00,"avg":90.91},{"posID":38,"posName":"תמך - עמדה 38  ח.א.","qty":27,"sum":2500.00,"avg":92.59},{"posID":40,"posName":"שינוע - עמדה 40 קפיטריה","qty":688,"sum":35179.00,"avg":51.13},{"posID":50,"posName":"בית קפה תמך - קופה 50 (קיוסק)","qty":44,"sum":2800.00,"avg":63.64},{"posID":51,"posName":"בית קפה תמך - קופה 51 (קיוסק)","qty":15,"sum":1253.00,"avg":83.53},{"posID":52,"posName":"בית קפה תמך - קופה 52 (קיוסק)","qty":5,"sum":318.00,"avg":63.60},{"posID":53,"posName":"בית קפה תמך - קופה 53 - הזמנות","qty":226,"sum":14650.00,"avg":64.82}]}));
                    }}
                    srcDoc={this.state.modalTemplateViewHtml ?? ""}
                    sandbox="allow-scripts"
                    style={{ width: '100%', height: '80vh', border: 'none' }}
                />
            </GenericModal>
        </div>)
    }
}
export default DashboardDinamic;
